// Selo "Transferido" na lista de conversas: DESLIGADO de vez (regra do dono,
// 2026-10-16). A InfinitSales mostra so o RESPONSAVEL do contato: membro ou
// agente ganham o selo com o nome; sem responsavel, nenhum selo. O "Transferido"
// vinha da InfinitAgents (estado de handoff) e nao faz parte desta logica.
//
// Historico: em 10/10 o selo ficou restrito ao handoff do agente para uma
// pessoa; em 16/10 o dono explicou que a regra de 10/10 era sobre o handoff
// SEM destino (contato fica sem responsavel e sem selo) e que o "Transferido"
// nunca deveria aparecer. A funcao continua existindo para os 3 shells (QR,
// Business e o compartilhado de IG/MS/widget) e devolve sempre "nao mostra".
export function transferidoBadge({ handoff, assigned, loading = false }) {
  void handoff;
  void assigned;
  void loading;
  return { show: false, title: '' };
}
